import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-gradient-to-b from-[#1a0a2e] to-[#5B2D8E] text-white text-center relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 pointer-events-none" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-46">
        <h2 className="text-3xl md:text-5xl font-extrabold leading-tight mb-8" data-id="element-47">
          El 16 de marzo puedes salir
          <br className="hidden md:block" data-id="element-48" /> siendo la misma persona que entró.
        </h2>

        <p className="text-2xl md:text-3xl text-[#F5A623] font-bold mb-6" data-id="element-49">
          O puedes salir habiendo roto
          <br className="hidden md:block" data-id="element-50" /> el límite que más te ha detenido.
        </p>

        <p className="text-xl md:text-2xl font-medium mb-12 text-gray-200" data-id="element-51">
          Tú decides.
        </p>

        <div className="flex flex-col items-center" data-id="element-52">
          <CTAButton className="text-xl md:text-2xl py-5 px-10 mb-4 shadow-[0_0_40px_rgba(245,166,35,0.5)]" data-id="element-53">
            🔥 RESERVA TU LUGAR AHORA — $5
          </CTAButton>

          <p className="text-lg font-medium text-white/80 mb-8" data-id="element-54">
            Quiero romper mi límite el 16 de marzo
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base text-white/70 mb-8 bg-black/20 py-3 px-6 rounded-full" data-id="element-55">
            <span className="flex items-center gap-2" data-id="element-56">✅ Solo 100 cupos</span>
            <span className="flex items-center gap-2" data-id="element-57">✅ Pago seguro</span>
            <span className="flex items-center gap-2" data-id="element-58">
              ✅ Confirmación inmediata
            </span>
          </div>

          <div className="flex justify-center gap-6 text-lg font-bold text-[#F5A623]" data-id="element-59">
            <span data-id="element-60">📍 Miami</span>
            <span data-id="element-61">🗓️ 16 de Marzo</span>
            <span data-id="element-62">🗣️ En Español</span>
          </div>
        </div>
      </div>
    </section>;
}